import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";

import Stars from '../../../Common/Stars';
import { constants } from '../../../../Helpers/Constants';
import { DivisionIcon, VCIcon } from '../../../Common/Buttons/TypeIcons';
import ProfileCell from '../User/ProfileCell';
import GeneratedTypeIcons from '../../../Common/GeneratedTypeIcons';
import { UserApproved, UserDeactivate, UserRejected, UserInvited, UserRequested, TagDefault, ActivityActive, ActivityInactive } from '../../../Common/Buttons/Icons';

//Pass a profile prop with the necessary details
class UserTierRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
    }

    setRowClass(customer) {
        var className;

        if ('bookings_made_last_three_months' in customer && customer.bookings_made_last_three_months.length > 0) {
            className = "row-active"
        } else if (('sh_vmh_access' in customer && customer.sh_vmh_access.length > 0 && moment(customer.sh_vmh_access[0].Created_At, "YYYY-MM-DD HH:mm:ss").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day'))) && (!('bookings_made_last_three_months' in customer) || customer.bookings_made_last_three_months.length == 0)) {
            className = 'row-inactive'
        }

        if (customer.Title === null && customer.Company === null) {
            className = className + " internaltag-row"
        }

        return className;
    }

    setUserStatusIcon(customer) {
        if (customer.status === 'Active') {
            return(
                UserApproved()
            )
        } else if (customer.status === 'Inactive') {
            return(
                UserDeactivate()
            )
        } else if (customer.status === 'Rejected') {
            return(
                UserRejected()
            )
        } else if (customer.status === 'Invited') {
            return(
                UserInvited()
            )
        } else if (customer.status === 'Pending') {
            return(
                UserRequested()
            )
        } else if (customer.status === 'Internal Tag') {
            return(
                TagDefault()
            )
        }
    }

    setBookingActivityIcon(customer) {
            if ('bookings_made_last_three_months' in customer && customer.bookings_made_last_three_months.length > 0) {
                return(ActivityActive())
            } else if ('sh_vmh_access' in customer && customer.sh_vmh_access.length > 0 && moment(customer.sh_vmh_access[0].Created_At, "YYYY-MM-DD HH:mm:ss").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day')) && (!('bookings_made_last_three_months' in customer) || customer.bookings_made_last_three_months.length == 0)) {
                return(ActivityInactive())
            } else {
                return (<img src = "images/png-icons/dash-grey.png"/>)
            }
    }

    render() {
        return (
            <tr className={this.setRowClass(this.props.customer)}>
                <td>
                    <ProfileCell history={this.props.history} match={this.props.match} location={this.props.location} profile={this.props.customer} showImage noTooltip/>
                    {/* 
                    <div className = "user-prof-img float-left">
                        <img src = "images/userrole/press.png" className = "userrole-img"/>
                    </div>
                    <div className = "user-prof-name float-left">
                        Joel Fuller
                        <div className = "caption">Journalist at autoTRADER</div>
                    </div>
                    */}
                </td>
                <td className = "single-img-cell">
                    {this.setBookingActivityIcon(this.props.customer)}
                </td>
                <td className = "multi-img-cell px-26 align-center">
                    <GeneratedTypeIcons customer={this.props.customer} type={'Department'} />
                </td>
                <td className = "multi-img-cell px-26 align-center">
                    <GeneratedTypeIcons customer={this.props.customer} type={'Centre'} />
                </td>
                <td className = "single-img-cell">
                    {this.props.customer.bookings.length}
                </td>
                <td className = "single-img-cell">
                    {
                        'last_booking' in this.props.customer && this.props.customer.last_booking !== null ?
                            moment(this.props.customer.last_booking.End_Date, "YYYY-MM-DD").format("MMM DD, YYYY")
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td className = "single-img-cell">
                    {
                        'sh_vmh_access' in this.props.customer && this.props.customer.sh_vmh_access.length > 0 ?
                            moment(this.props.customer.sh_vmh_access[0].Created_At, "YYYY-MM-DD HH:mm:ss").format("MMM DD, YYYY")
                        :
                            <img src = "images/png-icons/dash-grey.png"/> 
                    }
                </td>
                <td>
                    <Stars star={(this.props.data.profile_db[this.props.customer.ID].sh_vmh_access[0].tier.Rank)} type={"Profile"} ID={this.props.customer.ID} key={this.props.customer.ID} mutable={this.props.customer.has_authorizing ? "mutable" : ""} confirmable/>
                </td>
            </tr>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(UserTierRow)